import React, { MouseEventHandler, RefObject } from 'react';
import useTable from 'hooks/table/useTable';
import useCommonStore from 'store/useCommonStore';
import styled from 'styled-components';
import { IMatchDB } from 'utils/dummy';

interface ITableRow {
	row_idx: number;
	data: IMatchDB;
	_ref?: RefObject<HTMLDivElement>;
	_onClick?: MouseEventHandler<HTMLDivElement>;
}

const TableRow = ({ row_idx, data, _ref, _onClick }: ITableRow) => {
	const { header } = useCommonStore();
	const match_cell_mapper = useTable();
	return (
		<Row ref={_ref} onClick={_onClick}>
			{header.map((item, idx) => (
				<React.Fragment key={idx}>
					{match_cell_mapper[item.name](data, idx, row_idx)}
				</React.Fragment>
			))}
		</Row>
	);
};

const Row = styled.div`
	width: max-content;
	min-width: calc(100% - 32px);
	height: 65px;

	border-radius: 8px;
	margin-top: 8px;
	padding: 0 16px;
	/* cursor: pointer; */

	${({ theme }) => theme.common.flexStart}

	background-color: ${({ theme }) => theme.colors.gray.gray_white};
	border: 1px solid ${({ theme }) => theme.colors.gray.gray_white};

	/* &:hover {
		border-color: ${({ theme }) => theme.colors.gray.gray15};
		background-color: transparent;
	} */
`;

export default React.memo(TableRow);
